import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaInputSwitch'

type IcaInputSwitchProps = React.JSX.IntrinsicElements['tgdb-ica-input-switch']

export const IcaInputSwitch = wrapWc<IcaInputSwitchProps>('tgdb-ica-input-switch', [])
